/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Mode_AgentInputs */



/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Assistant_Mode_AgentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_mode_agent = /** @type {((inputs?: Assistant_Mode_AgentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Mode_AgentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Agent")
	if (locale === "it") return /** @type {LocalizedString} */ ("Agente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Агент")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エージェント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिनिधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Agente")
	return /** @type {LocalizedString} */ ("Agent")
});